import React from 'react';
import { ExternalLink, Gift, CheckCircle } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Netbet',
      url: 'https://www.netbet.fr/',
      bonus: 'Bonus de bienvenue de 100€',
      description: 'Doublez votre premier dépôt jusqu\'à 100€ et profitez d\'une interface intuitive pour vos paris sportifs.',
      features: ['Cotes compétitives', 'Cash-out disponible', 'Application mobile optimisée'],
      color: 'from-blue-500/20 to-cyan-500/20',
      borderColor: 'border-blue-400/50',
      buttonColor: 'bg-blue-500 hover:bg-blue-600',
    },
    {
      id: 2,
      name: 'Unibet',
      url: 'https://www.unibet.fr/',
      bonus: '10€ de dépôt gratuit + 100€ de bonus',
      description: 'Commencez avec 10€ offerts sans dépôt, puis bénéficiez d\'un bonus de 100€ sur votre premier versement.',
      features: ['10€ offerts sans dépôt', 'Bonus jusqu\'à 100€', 'Streaming en direct'],
      color: 'from-green-500/20 to-emerald-500/20',
      borderColor: 'border-green-400/50',
      buttonColor: 'bg-green-500 hover:bg-green-600',
    },
    {
      id: 3,
      name: 'Vbet',
      url: 'https://vbet.fr/',
      bonus: 'Bonus de bienvenue de 100€',
      description: 'Rejoignez un opérateur reconnu et obtenez jusqu\'à 100€ de bonus pour débuter vos paris en toute confiance.',
      features: ['Pari en direct', 'Multiples sports', 'Support réactif'],
      color: 'from-purple-500/20 to-pink-500/20',
      borderColor: 'border-purple-400/50',
      buttonColor: 'bg-purple-500 hover:bg-purple-600',
    },
  ];

  return (
    <section id="offers" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-toxic-green to-toxic-cyan bg-clip-text text-transparent">
              Offres exclusives
            </span>
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Sélectionnez l'offre qui correspond à vos attentes et commencez à parier avec un avantage dès aujourd'hui.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" itemScope itemType="https://schema.org/ItemList">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              className={`glass-strong rounded-xl p-6 border-2 ${offer.borderColor} hover:scale-105 transition-all duration-300 relative overflow-hidden`}
              itemScope
              itemType="https://schema.org/Offer"
              itemProp="itemListElement"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${offer.color} opacity-50 -z-10`}></div>
              
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 glass rounded-lg flex items-center justify-center">
                    <Gift className="w-6 h-6 text-toxic-green" />
                  </div>
                  <h3 className="text-2xl font-bold text-white" itemProp="name">{offer.name}</h3>
                </div>
              </div>

              <div className="mb-4">
                <p className="text-toxic-green font-semibold mb-2 flex items-center gap-2" itemProp="description">
                  <Gift className="w-4 h-4" />
                  {offer.bonus}
                </p>
                <p className="text-white/80 text-sm leading-relaxed" itemProp="description">{offer.description}</p>
              </div>

              <ul className="mb-6 space-y-2">
                {offer.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-white/70">
                    <CheckCircle className="w-4 h-4 text-toxic-green flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>

              <a
                href={offer.url}
                target="_blank"
                rel="noopener noreferrer nofollow sponsored"
                className={`${offer.buttonColor} text-white font-bold py-3 px-6 rounded-lg w-full flex items-center justify-center gap-2 transition-all hover:shadow-lg`}
                itemProp="url"
              >
                Jouer sur {offer.name}
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

